// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__102C4","productName":"Table_productName__2j_Rx"};